<template>
  <v-row align="center" class="px-4 pt-4">
    <div class="page-header-left px-4 py-6">
      <h3 class="text-h4 px-3" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;">{{ pageTitle }}</h3>
    </div>
    <!-- <v-breadcrumbs divider="/" :items="breadcrumbItems" large>
      <template v-slot:item="props">
        <router-link v-if="props.item.home" :to="props.item.href" class="enabled">
          <v-icon size="19">mdi-home</v-icon>
        </router-link>
        <a v-else-if="props.item.disabled" class="disabled">
          {{ props.item.text }}
        </a>
        <router-link v-else :to="props.item.href" class="enabled">
          {{ props.item.text }}
        </router-link>
      </template>
    </v-breadcrumbs> -->
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import menu from '../config/menu'

export default {
  name: 'app-page-header',

  data: () => ({
    title: ''
  }),

  computed: {
    ...mapGetters(['BREADCRUMB']),
    pageTitle () {
      return this.$route.meta.title
    },
    breadcrumbItems () {
      let items = []
      let isMenuItem = false

      // agregando elemento de inicio al breadcrumb
      items.push({
        home: true,
        href: { name: 'Dashboard' }
      })

      // construyendo el breadcrumb
      if (this.BREADCRUMB === null) {
        menu.forEach(item => {
          if (item.items) {
            let child = item.items.find(i => {
              return i.component === this.$route.name
            })
            if (child) {
              items.push({
                text: item.title,
                disabled: true
              })
              items.push({
                text: child.title,
                disabled: true
              })
              isMenuItem = true
            }
          } else {
            if (item.name === this.$route.name) {
              items.push({
                text: item.title,
                disabled: true
              })
              isMenuItem = true
            }
          }
        })

        if (!isMenuItem) {
          if (this.$route.meta.parentMenu) {
            let parent = null

            menu.forEach(e => {
              if (e.name === this.$route.meta.parentMenu) {
                parent = e
              } else if (e.items) {
                let subparent = e.items.find(i => {
                  return i.name === this.$route.meta.parentMenu
                })
                if (subparent) {
                  items.push({
                    text: e.title,
                    disabled: true
                  })

                  parent = subparent
                }
              }
            })

            if (parent) {
              items.push({
                text: parent.title,
                href: { name: parent.name }
              })
            }
          }

          items.push({
            text: this.$route.meta.title,
            disabled: true
          })
        }
      } else {
        this.BREADCRUMB.forEach(el => {
          items.push(el)
        })
      }

      return items
    }
  }
}
</script>

<style scoped>
  .disabled {
    color: grey;
    pointer-events: none;
  }
  .enabled {
    text-decoration: none;
  }
</style>
